import useSupportInfo from './useSupportInfo';
export * from './useSupportInfo';
export default useSupportInfo;
